import { Component, OnInit, Input } from '@angular/core';

import { OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'app-carousel-wrapper2',
  templateUrl: './carousel-wrapper2.component.html',
  styleUrls: ['./carousel-wrapper2.component.scss']
})
export class CarouselWrapper2Component implements OnInit {
  
  @Input() carouselWrapper2Type:string;

  limit: number = 10; // <==== Edit this number to limit API results
  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    center: false,
    dots: false,
    autoHeight: true,
    autoWidth: true,
    nav: true,
    navText: [ '<i class="ri-arrow-left-s-line"></i>', '<i class="ri-arrow-right-s-line"></i>' ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      769: {
        items: 3,
      },
    }
  }
  constructor() { }

  ngOnInit(): void {
  }

}
